import { render, staticRenderFns } from "./AddressPropositions.vue?vue&type=template&id=41131a87"
import script from "./AddressPropositions.vue?vue&type=script&lang=ts"
export * from "./AddressPropositions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports